import React, { useState, useEffect } from "react";
import styles from "./FinanceTable.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import pdfIcon from "../../assets/images/pdfIcon.png";
import { Icon } from "../../assets/Icons.tsx";

interface CardDataProps {
  cardData: {
    year?: number;
    title?: string;
    companyName?: string;
  }[];
  SubsidiaryCompanies?: Boolean;
  financialYear?: string;
}
const FinanceTable: React.FC<CardDataProps> = ({
  cardData,
  SubsidiaryCompanies,
  financialYear,
}) => {
  const [showSingleRelease] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth < 1025);
    };

    updateView();
    window.addEventListener("resize", updateView);

    return () => window.removeEventListener("resize", updateView);
  }, []);
  const downloadFile = async (fileUrl, fileName) => {
    const url = fileUrl;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  return (
    <div id="FinanceTable" className={`${styles.FinanceTable} mt-4`}>
      {!isMobile && (
        <>
          {!showSingleRelease && (
            <>
              {!SubsidiaryCompanies && (
                <>
                  <div className={`row g-0 ${styles.header}`}>
                    <div className="col-3 d-flex justify-content-start align-items-center">
                      <p className="para caps fw-bold mb-0">
                        financial year (FY)
                      </p>
                    </div>
                    <div className="col-7 d-flex justify-content-start align-items-center">
                      <p className="para caps fw-bold mb-0 ">title</p>
                    </div>
                    <div className="col-1 d-flex justify-content-center align-items-center">
                      <p className="para caps fw-bold mb-0">View</p>
                    </div>
                    <div className="col-1 d-flex justify-content-center align-items-center">
                      <p className="para caps fw-bold mb-0">Download</p>
                    </div>
                  </div>
                  <div className="mb-3">
                    {cardData?.map((card, index) => (
                      <div
                        className={`row g-0 ${styles.brandCard} mt-2 align-items-stretch`}
                        key={index}
                      >
                        <div className="col-3 d-flex justify-content-start align-items-center">
                          <p className={`para mb-0`}> FY {financialYear}</p>
                        </div>

                        <div className="col-7 d-flex justify-content-start align-items-center">
                          <img src={pdfIcon} alt="pdfIcon" />
                          <p className={`para mb-0 ${styles.titleStyle}`}>
                            {card?.file_title}
                          </p>
                        </div>
                        <div className="col-1 d-flex justify-content-center align-items-center">
                          <div style={{ cursor: "pointer" }}>
                            <a
                              href={card?.file_path}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon
                                name="eyeIcon"
                                color="#036995"
                                height="35px"
                                width="35px"
                              />
                            </a>
                          </div>
                        </div>
                        <div className="col-1 d-flex justify-content-center align-items-center">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(card.file_path, card.file_name)
                            }
                          >
                            <Icon
                              name="circleDownArrow"
                              color="#036995"
                              height="35px"
                              width="35px"
                            />
                          </span>
                        </div>
                      </div>
                    ))}
                    {cardData?.length === 0 && (
                      <div className={`${styles.brandCard} p-0 mt-2`}>
                        <p className="subHeading text-center caps mt-4 mb-4">
                          No Data available
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
              {SubsidiaryCompanies && (
                <>
                  <p className="para mt-4 text-uppercase">
                    <strong>financial year (FY) - </strong>
                    {financialYear}
                  </p>
                  <div className={`row g-0 ${styles.header}`}>
                    <div className="col-5 d-flex justify-content-start align-items-center">
                      <p className="para caps fw-bold mb-0 p-2">Company</p>
                    </div>
                    <div className="col-5 d-flex justify-content-start align-items-center">
                      <p className="para caps fw-bold mb-0 p-2">
                        audited accounts
                      </p>
                    </div>
                    <div className="col-1 d-flex justify-content-center align-items-center">
                      <p className="para caps fw-bold mb-0 p-2">View</p>
                    </div>
                    <div className="col-1 d-flex justify-content-center align-items-center">
                      <p className="para caps fw-bold mb-0 p-2">Download</p>
                    </div>
                  </div>
                  <div className="mb-3">
                    {cardData?.map((card, index) => (
                      <div
                        className={`row g-0 ${styles.brandCard} mt-2 align-items-stretch`}
                        key={index}
                      >
                        <div className="col-5 d-flex justify-content-start align-items-center">
                          <p className={`para mb-0`}>{card.file_title}</p>
                        </div>

                        <div className="col-5 d-flex justify-content-start align-items-center">
                          <img src={pdfIcon} alt="pdfIcon" />
                          <p className={`para mb-0 ${styles.titleStyle}`}>
                            {card.file_name}
                          </p>
                        </div>
                        <div className="col-1 d-flex justify-content-center align-items-center">
                          <a
                            href={card?.file_path}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Icon
                              name="eyeIcon"
                              color="#036995"
                              height="35px"
                              width="35px"
                            />
                          </a>
                        </div>
                        <div className="col-1 d-flex justify-content-center align-items-center">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(card.file_path, card.file_name)
                            }
                          >
                            <Icon
                              name="circleDownArrow"
                              color="#036995"
                              height="35px"
                              width="35px"
                            />
                          </span>
                        </div>
                      </div>
                    ))}
                    {cardData?.length === 0 && (
                      <div className={`${styles.brandCard} p-0 mt-2`}>
                        <p className="subHeading text-center caps mt-4 mb-4">
                          No Data available
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
      {isMobile && (
        <>
          {!showSingleRelease && (
            <>
              {!SubsidiaryCompanies && (
                <>
                  <div className="mb-3">
                    {cardData?.map((card, index) => (
                      <div
                        className={`${styles.brandCard} mt-2 align-items-stretch`}
                        key={index}
                      >
                        <div
                          style={{
                            height: "10px",
                            backgroundColor: "#E1C78C",
                            borderTopLeftRadius: "15px",
                            borderTopRightRadius: "15px",
                          }}
                        ></div>
                        <div className="p-3">
                          <div>
                            <p className={`para mb-0`}>
                              <strong className="text-uppercase">
                                financial year (FY):
                              </strong>{" "}
                              {financialYear} {card.year}
                            </p>
                            <p
                              className={`para mb-0 pt-2`}
                              style={{ textAlign: "left" }}
                            >
                              <strong className="text-uppercase">Title:</strong>{" "}
                              <img src={pdfIcon} alt="pdfIcon" />{" "}
                              <span className={styles.titleStyle}>
                                {card.file_title}
                              </span>
                            </p>
                          </div>

                          <div className="d-flex justify-content-end pt-4">
                            <div>
                              <a
                                href={card?.file_path}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <Icon
                                  name="eyeIcon"
                                  color="#036995"
                                  height="35px"
                                  width="35px"
                                />
                              </a>
                            </div>
                            <div style={{ paddingLeft: "15px" }}>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadFile(card.file_path, card.file_name)
                                }
                              >
                                <Icon
                                  name="circleDownArrow"
                                  color="#036995"
                                  height="35px"
                                  width="35px"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {cardData?.length === 0 && (
                      <div className={`${styles.brandCard} p-0 mt-2`}>
                        <p className="subHeading text-center caps mt-4 mb-4">
                          No Data available
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
              {SubsidiaryCompanies && (
                <>
                  <p className="para mt-4 text-uppercase">
                    <strong>financial year (FY) - </strong>
                    {financialYear}
                  </p>

                  <div className="mb-3">
                    {cardData?.map((card, index) => (
                      <div
                        className={`${styles.brandCard} mt-2 align-items-stretch`}
                        key={index}
                      >
                        <div
                          style={{
                            height: "10px",
                            backgroundColor: "#E1C78C",
                            borderTopLeftRadius: "15px",
                            borderTopRightRadius: "15px",
                          }}
                        ></div>
                        <div className="p-3">
                          <div>
                            <p className={`para`} style={{ textAlign: "left" }}>
                              <strong className="text-uppercase">
                                Company:
                              </strong>{" "}
                              {card.file_title}
                            </p>
                            <p className={`para`} style={{ textAlign: "left" }}>
                              {" "}
                              <strong className="text-uppercase">
                                audited accounts:
                              </strong>
                              <p>
                                <img src={pdfIcon} alt="pdfIcon" />{" "}
                                {card.file_name}
                              </p>
                            </p>
                          </div>

                          <div className="d-flex justify-content-end pt-2">
                            <div>
                              <a
                                href={card?.file_path}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <Icon
                                  name="eyeIcon"
                                  color="#036995"
                                  height="35px"
                                  width="35px"
                                />
                              </a>
                            </div>
                            <div style={{ paddingLeft: "15px" }}>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadFile(card.file_path, card.file_name)
                                }
                              >
                                <Icon
                                  name="circleDownArrow"
                                  color="#036995"
                                  height="35px"
                                  width="35px"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {cardData?.length === 0 && (
                      <div className={`${styles.brandCard} p-0 mt-2`}>
                        <p className="subHeading text-center caps mt-4 mb-4">
                          No Data available
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
               
            </>
          )}
        </>
      )}
    </div>
  );
};

export default FinanceTable;
